export default {
  root: {
    class: [
      // Shape
      'rounded-md shadow-lg',
      'border-0 dark:border',

      // Position
      'absolute left-0 top-0 mt-2',
      'z-40 transform origin-center',

      // Color
      'bg-surface-1000',
      'text-white',
      'border-transparent',

      // Before: Triangle
      'before:absolute before:-top-2 before:-ml-[9px] before:left-[calc(var(--overlayArrowLeft,0)+1.25rem)] z-0',
      'before:w-0 before:h-0',
      'before:border-transparent before:border-solid',
      'before:border-x-8 before:border-8',
      'before:border-t-0 before:border-b-surface-1000',

      'after:absolute after:-top-2 after:-ml-2 after:left-[calc(var(--overlayArrowLeft,0)+1.25rem)]',
      'after:w-0 after:h-0',
      'after:border-transparent after:border-solid',
      'after:border-x-8 after:border-8',
      'after:border-t-0 after:border-b-surface-1000'
    ]
  },
  content: {
    class: 'p-2 items-center flex'
  },
  transition: {
    enterFromClass: 'opacity-0 scale-y-[0.8]',
    enterActiveClass:
      'transition-[transform,opacity] duration-[120ms] ease-[cubic-bezier(0,0,0.2,1)]',
    leaveActiveClass: 'transition-opacity duration-100 ease-linear',
    leaveToClass: 'opacity-0'
  }
}
